/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {Injectable} from '@angular/core';
import {AppEnum} from '../../constants/app.enum';

@Injectable({
  providedIn: 'root',
})
export class DevicePlatformService {
  getPlatform(): string {
    const userAgent = navigator.userAgent || window.opera;

    if (/android/i.test(userAgent)) {
      return AppEnum.PLATFORM_ANDROID;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return AppEnum.PLATFORM_IOS;
    }

    if (/Macintosh|Mac OS X/i.test(userAgent)) {
      return AppEnum.PLATFORM_MACOS;
    }

    if (/Windows NT/i.test(userAgent)) {
      return AppEnum.PLATFORM_WINDOWS;
    }

    return AppEnum.PLATFORM_OTHER;
  }
}
